/**
 * SMS/OTP Service
 * One-time password and SMS verification service
 */
import { otpClient, smsClient } from "./client";

export const smsService = {
  /**
   * Send OTP to mobile number
   * @param {string} mobileNumber - Mobile number to send OTP
   */
  sendOTP(mobileNumber) {
    return otpClient.post("/otp/send", { mobileNumber });
  },

  /**
   * Verify OTP code
   * @param {string} mobileNumber - Mobile number
   * @param {string} code - OTP code to verify
   */
  verifyOTP(mobileNumber, code) {
    return otpClient.post("/otp/verify", { mobileNumber, code });
  },

  /**
   * Resend OTP
   * @param {string} mobileNumber - Mobile number to resend OTP
   */
  resendOTP(mobileNumber) {
    return otpClient.post("/otp/resend", { mobileNumber });
  },

  /**
   * Send SMS notification
   * @param {Object} data - SMS data (recipient, message, etc.)
   */
  sendSMS(data) {
    return smsClient.post("/sms/send", data);
  },
};

export default smsService;
